import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './met-type-donor-moral.reducer';
import { IMetTypeDonorMoral } from 'app/shared/model/met-type-donor-moral.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetTypeDonorMoral = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const metTypeDonorMoralList = useAppSelector(state => state.metTypeDonorMoral.entities);
  const loading = useAppSelector(state => state.metTypeDonorMoral.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="met-type-donor-moral-heading" data-cy="MetTypeDonorMoralHeading">
        <Translate contentKey="almobadaraMasterDataApp.metTypeDonorMoral.home.title">Met Type Donor Morals</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.metTypeDonorMoral.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.metTypeDonorMoral.home.createLabel">Create new Met Type Donor Moral</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {metTypeDonorMoralList && metTypeDonorMoralList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metTypeDonorMoral.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metTypeDonorMoral.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metTypeDonorMoral.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metTypeDonorMoral.nameAr">Name Ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metTypeDonorMoral.nameEn">Name En</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metTypeDonorMoral.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {metTypeDonorMoralList.map((metTypeDonorMoral, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${metTypeDonorMoral.id}`} color="link" size="sm">
                      {metTypeDonorMoral.id}
                    </Button>
                  </td>
                  <td>{metTypeDonorMoral.code}</td>
                  <td>{metTypeDonorMoral.name}</td>
                  <td>{metTypeDonorMoral.nameAr}</td>
                  <td>{metTypeDonorMoral.nameEn}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${metTypeDonorMoral.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${metTypeDonorMoral.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${metTypeDonorMoral.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${metTypeDonorMoral.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.metTypeDonorMoral.home.notFound">No Met Type Donor Morals found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default MetTypeDonorMoral;
